import { render, staticRenderFns } from "./SunmiBK.vue?vue&type=template&id=2379ffee&scoped=true"
import script from "./SunmiBK.vue?vue&type=script&lang=js"
export * from "./SunmiBK.vue?vue&type=script&lang=js"
import style0 from "./SunmiBK.vue?vue&type=style&index=0&id=2379ffee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379ffee",
  null
  
)

export default component.exports